import React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { Link } from "react-router-dom";

const BuyProject = () => {
  return (
    <Grid item xs={12} sm={12} md={12}>
      <Link to="/Buyprojects" id="lnk">
        <Paper id="sell" style={{ textShadow: "black", marginTop: "-20px" }}>
          <h1 id="sellbanner">BUY C.S.E PROJECTS HERE</h1>
          <Divider style={{ backgroundColor: "white" }} />
          <p style={{ color: "white", textShadow: "black" }} id="Ttag">
            5th sem DBMS project Available
          </p>
          <p style={{ color: "white", textShadow: "black" }} id="Ttag">
            6th sem C.G project Available
          </p>
          <p style={{ color: "white", textShadow: "black" }} id="Ttag">
            7th sem WEB project Available
          </p>
          <Divider style={{ backgroundColor: "white" }} />
          <p
            style={{
              color: "white",
              textShadow: "black",
              textAlign: "left",
              padding: "5px"
            }}
            id="Ttag"
          >
            Contact : +91 9591379239 (whatsApp Available) <br />
            Email : viewnotes19@gmail.com
          </p>
          <p
            id="sellbanner"
            style={{
              color: "white",
              textShadow: "black",
              textAlign: "left",
              padding: "5px"
            }}
          >
            Projects are in limited quantity, contact soon.
          </p>

          <p
            style={{
              color: "white",
              textShadow: "black",
              fontSize: "10px"
            }}
            id="Ttag"
          >
            Click on this banner for more information
          </p>
        </Paper>
      </Link>
    </Grid>
  );
};

export default BuyProject;
